import store from "@/store";
import Vue from "vue";
//import { Logger } from "@storefront/core/lib/logger";
import { i18n } from "@storefront/core/i18n";
import { validatePostcodeWithAddition } from "@storefront/core/data-resolver/user";
export default Vue.extend({
  async mounted() {
    await store.dispatch("user/loadUser");
  },
  computed: {
    /**
     *
     * @returns true or false
     */
    isLoggedIn: function () {
      return store.getters["user/getIsLoggedIn"];
    },
  },
  data() {
    return {
      emailReg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  methods: {
    /**
     * subscribe to newsletter
     * @param {string} email
     */
    async subscribe(email) {
      let valid = true;
      if (email == "") {
        const msg = {
          type: "danger",
          title: i18n.t("newsletter_error"),
          text: i18n.t("email_is_required_field"),
        };
        store.dispatch("messages/sendMessage", { message: msg });
        valid = false;
      } else if (!this.emailReg.test(email)) {
        const msg = {
          type: "danger",
          title: i18n.t("newsletter_error"),
          text: i18n.t("email_is_invalid_field"),
        };
        store.dispatch("messages/sendMessage", { message: msg });
        valid = false;
      }
      if (valid == true) {
        const retval = await store.dispatch("user/newsletterSignup", {
          email: email,
        });
        if (retval != false) {
          const msg = {
            type: "success",
            title: i18n.t("newsletter_success"),
            text: i18n.t("newsletter_subscribed"),
          };
          store.dispatch("messages/sendMessage", { message: msg });
        }
      }
    },
    async validatePostcodeHouseNumber(formAddress = this.form.address) {
      if ((this.showFullAddress == false || this.showFullInvoiceAddress == false) && formAddress.country_code == "NL") {
        const { filtered: list, original } = await validatePostcodeWithAddition(
          formAddress.postcode,
          formAddress.house_number,
          formAddress.addition,
          this.selectedAddress
        );

        if (formAddress.addition === "") {
          this.cachedAddressList = original;
        }

        if (list.length === 1) {
          const matchedAddress = list[0];
          formAddress.house_numberError = '';
          formAddress.streetDisplay = matchedAddress.street;
          formAddress.streetDisplayState = true;
          formAddress.city = matchedAddress.city;
          formAddress.cityState = true;
          formAddress.house_numberState = true;
          if (
            formAddress.addition === matchedAddress.additionString ||
            matchedAddress.additionString === ""
          ) {
            formAddress.addition = matchedAddress.additionString;
            formAddress.additionState = true;

            if (formAddress === this.form.address) {
              this.foundAddresses = [];
              this.foundAddress = matchedAddress.text;
              this.selectedAddress = null;
            } else if (formAddress === this.form.invoice.address) {
              this.foundInvoiceAddresses = [];
              this.foundInvoiceAddress = matchedAddress.text;
              this.selectedInvoiceAddress = null;
            }
          } else {
            formAddress.additionState = false;

            if (formAddress === this.form.address) {
              this.foundAddresses = [matchedAddress];
              this.foundAddress = "";
              this.selectedAddress = null;
            } else if (formAddress === this.form.invoice.address) {
              this.foundInvoiceAddresses = [matchedAddress];
              this.foundInvoiceAddress = "";
              this.selectedInvoiceAddress = null;
            }
          }
          return;
        }
        if (list.length === 0 && original.length === 1) {
          const fallbackAddress = original[0];
          formAddress.house_numberError = '';
          formAddress.streetDisplay = fallbackAddress.street;
          formAddress.streetDisplayState = true;
          formAddress.city = fallbackAddress.city;
          formAddress.cityState = true;
          formAddress.house_numberState = true;
          formAddress.additionState = false;
          if (formAddress === this.form.address) {
            this.foundAddresses = [fallbackAddress];
            this.foundAddress = "";
            this.selectedAddress = null;
          } else if (formAddress === this.form.invoice.address) {
            this.foundInvoiceAddresses = [fallbackAddress];
            this.foundInvoiceAddress = "";
            this.selectedInvoiceAddress = null;
          }

          return;
        }
        if (list.length === 0) {
          formAddress.house_numberState = null;

          if (formAddress === this.form.address) {
            this.foundAddress = "";
            this.foundAddresses = [];
          } else if (formAddress === this.form.invoice.address) {
            this.foundInvoiceAddress = "";
            this.foundInvoiceAddresses = [];
          }

          if (formAddress.addition !== "" && this.cachedAddressList.length > 0) {
            formAddress.additionState = false;

            if (formAddress === this.form.address) {
              this.foundAddresses = [...this.cachedAddressList];
              this.selectedAddress = null;
            } else if (formAddress === this.form.invoice.address) {
              this.foundInvoiceAddresses = [...this.cachedAddressList];
              this.selectedInvoiceAddress = null;
            }
            return;
          } else {
            formAddress.additionState = null;
            if (
              formAddress === this.form.address &&
              this.foundAddresses.length === 0 &&
              original.length === 0
            ) {
              this.foundAddress = this.$t("unknown_postcode_combination");
            } else if (
              formAddress === this.form.invoice.address &&
              this.foundInvoiceAddresses.length === 0 &&
              original.length === 0
            ) {
              this.foundInvoiceAddress = this.$t("unknown_postcode_combination");
            }

            return;
          }
        }
        if (list.length > 1) {
          formAddress.house_numberError = '';
          formAddress.additionState = null;

          if (formAddress === this.form.address) {
            this.foundAddresses = [];
            this.selectedAddress = null;
          } else if (formAddress === this.form.invoice.address) {
            this.foundInvoiceAddresses = [];
            this.selectedInvoiceAddress = null;
          }

          list.forEach(item => {
            if (formAddress === this.form.address) {
              this.foundAddresses.push(item);
            } else if (formAddress === this.form.invoice.address) {
              this.foundInvoiceAddresses.push(item);
            }
          });
          return;
        }
      } else {
        if (formAddress.postcode === "") {
          formAddress.postcodeState = false;
          formAddress.postcodeError = this.$t("postcode_required");
        } else {
          formAddress.postcodeState = true;
        }
      }
    },
  },
});
